import React from 'react'
import Popover from '@mui/material/Popover'
import {styled} from 'common'
import Autocomplete from 'components/Control/Autocomplete'
import {useUrlParams} from 'services/hooks'
import {useTranslation} from 'react-i18next'
import BasicDatePicker from 'components/Control/BasicDatePicker'
import {isSameKey} from 'utils'

const addTranslate = (values, t) => {
    return values?.map((v) => {
        if (v?.key) {
            return {
                key: v.key,
                name: t(`selectOptions.${v.name}`, {
                    defaultValue: v.name,
                }),
            }
        } else {
            return {
                key: v,
                name: t(`selectOptions.${v}`, {
                    defaultValue: v,
                }),
            }
        }
    })
}
const Filters = ({open, onClose, anchorEl, filters}) => {
    const {urlParams} = useUrlParams()
    const {t} = useTranslation()
    return (
        <Popover
            open={open}
            onClose={() => onClose(false)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}>
            <FilterContainer>
                {filters &&
                    Object.entries(filters)?.map(([key, value]) => {
                        if (value?.type === 'date') {
                            return (
                                <BasicDatePicker
                                    key={`key_filter_${key}`}
                                    label={t(`filters.${key}`)}
                                    name={key}
                                />
                            )
                        }
                        const defaultValue =
                            urlParams[key]?.split(',').filter((item) => item !== '') || []

                        const defaultValues = value
                            ?.filter((item) => defaultValue.includes(item.key || item))
                            .map((item) => item.name || item)
                        return (
                            <Autocomplete
                                key={`key_filter_${key}}`}
                                label={t(`filters.${key}`)}
                                options={addTranslate(value, t)}
                                labelKey={key}
                                multiple={true}
                                defaultValue={addTranslate(defaultValues, t)}
                                disableCloseOnSelect
                                sx={{width: 300}}
                                isOptionEqualToValue={isSameKey}
                            />
                        )
                    })}
            </FilterContainer>
        </Popover>
    )
}

export default Filters

const FilterContainer = styled.div`
    padding: 20px;
    flex-direction: column;
    display: flex;
    gap: 10px;
`
